module.exports = __webpack_public_path__ + "static/media/businessgoals.d766f503.png";